// One card per sub-feature, each carrying its PRD reference.
import React from 'react';
import { FiArrowRight, FiLock } from 'react-icons/fi';
import s from '../BudgetOptimiser.module.css';
import { money } from '../format';

export default function FeatureCards({ data, loading, onOpen }) {
  if (loading && !data) {
    return (
      <div className={s.cardGrid}>
        {[0, 1, 2, 3, 4, 5].map((i) => <div key={i} className={s.cardSkeleton} />)}
      </div>
    );
  }
  if (!data?.cards?.length) return null;

  return (
    <div className={s.cardGrid}>
      {data.cards.map((card) => {
        const clickable = card.state !== 'unavailable';
        return (
          <section key={card.key}
                   className={`${s.card} ${s[`card_${card.state}`] || ''} ${clickable ? s.cardOpen : ''}`}
                   onClick={clickable ? () => onOpen(card.tab) : undefined}
                   role={clickable ? 'button' : undefined}
                   tabIndex={clickable ? 0 : undefined}
                   onKeyDown={clickable ? (e) => {
                     if (e.key === 'Enter' || e.key === ' ') {
                       e.preventDefault(); onOpen(card.tab);
                     }
                   } : undefined}>
            <header className={s.cardHead}>
              <span className={s.cardRef}>{card.ref}</span>
              {clickable ? <FiArrowRight className={s.cardGo} />
                : <FiLock className={s.cardLock} />}
            </header>
            <h3 className={s.cardTitle}>{card.title}</h3>
            <p className={s.cardQuestion}>{card.question}</p>
            <div className={s.cardHeadline}>
              <span className={s.cardValue}>{card.headline}</span>
            </div>
            <p className={s.cardDetail}>{card.detail}</p>
            {card.state === 'found' && (
              <ul className={s.cardList}>
                {card.actions > 0 && (
                  <li>
                    <span className={s.cardTerm}>To decide</span>
                    <span className={s.cardFigure}>{card.actions}</span>
                  </li>
                )}
                {card.probes > 0 && (
                  <li className={s.cardNote}>{card.probes} are tests, not full moves.</li>
                )}
                {card.needs_cost > 0 && (
                  <li className={s.cardNote}>
                    {card.needs_cost} need a product cost first.
                  </li>
                )}
                {card.pauses > 0 && (
                  <li className={s.cardNote}>
                    {card.pauses} suggested for pausing — no bid can fix them.
                  </li>
                )}
                {card.cannot_help > 0 && (
                  <li className={s.cardNote}>
                    {card.cannot_help} will run out whatever you do.
                  </li>
                )}
                {card.unfunded > 0 && (
                  <li className={s.cardNote}>
                    {card.unfunded} need money the month does not have.
                  </li>
                )}
                {card.frees_per_day > 0 && (
                  <li>
                    <span className={s.cardTerm}>Frees a day</span>
                    <span className={s.cardFigure}>
                      {money(card.frees_per_day, data.currency)}
                    </span>
                  </li>
                )}
                {card.reserve > 0 && (
                  <li>
                    <span className={s.cardTerm}>Held for events</span>
                    <span className={s.cardFigure}>
                      {money(card.reserve, data.currency)}
                    </span>
                  </li>
                )}
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
